/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equal use of two synonymous codons gives RSCU 1.0 for each.`)
};

const es_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El uso igualitario de dos codones sinónimos da un RSCU de 1.0 para cada uno.`)
};

const de_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleiche Nutzung zweier synonymer Codons ergibt für jedes einen RSCU-Wert von 1,0.`)
};

const nl_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelijk gebruik van twee synonieme codons geeft RSCU 1,0 voor elk.`)
};

const fr_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'usage égal de deux codons synonymes donne un RSCU de 1,0 pour chacun.`)
};

const it_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'uso uguale di due codoni sinonimi dà RSCU 1,0 per ciascuno.`)
};

const pt_br2_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O uso igual de dois códons sinônimos dá RSCU 1,0 para cada um.`)
};

const pt_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O uso igual de dois codões sinónimos dá um RSCU de 1,0 para cada um.`)
};

const ja_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの同義コドンが均等に使われる場合、それぞれのRSCUは1.0になります。`)
};

const zh_rscu_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两个同义密码子被均等使用时，各自的 RSCU 为 1.0。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_ex1", locale)
	if (locale === "en") return en_rscu_ex1(inputs)
	if (locale === "es") return es_rscu_ex1(inputs)
	if (locale === "de") return de_rscu_ex1(inputs)
	if (locale === "nl") return nl_rscu_ex1(inputs)
	if (locale === "fr") return fr_rscu_ex1(inputs)
	if (locale === "it") return it_rscu_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_ex1(inputs)
	if (locale === "pt") return pt_rscu_ex1(inputs)
	if (locale === "ja") return ja_rscu_ex1(inputs)
	return zh_rscu_ex1(inputs)
};